import styled from "styled-components";
import axisSvg from "../../../images/axis/axis.svg";
import { CircularProgressBar } from "../../progress-bar/CircularProgressBar";
import { getImage } from "../../../utils/utils";

const AxisCard = ({ name, picture, advancement }) => {
  return (
    <div style={{ breakInside: "avoid", position: "relative" }}>
      <Card>
        {CircularProgressBar(Math.round(advancement))}
        <FirstSection>
          <Img>
            <img src={getImage(picture, axisSvg)} alt={"image de " + name} />
          </Img>
          <h2>{name}</h2>
        </FirstSection>
      </Card>
    </div>
  );
};
const Card = styled.div`
  box-shadow: 1px 1px 5px rgb(0 0 0 / 10%);
  background-color: var(--color-white);
  border-radius: 15px;
  padding: 2rem;
  width: 350px;
  display: flex;
  align-items: center;
  flex-direction: column;

  #circular-progress-bar {
    position: absolute;
    right: -15px;
    top: 10px;
    h4 {
      bottom: 47px;
    }
  }
  .rc-progress-circle {
    height: 70px;
    width: 70px;
  }
  @media print {
    width: 250px;
    box-shadow: none;
  }
`;

const FirstSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

const Img = styled.div`
  height: 5rem;
  width: 5rem;
  border-radius: 5px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
export default AxisCard;
